import React from 'react'
import { Link, usePage } from '@inertiajs/inertia-react'
import {
    canEditSiaModule,
    canViewSiaModule,
    hasAnySiaCapacitacionMenuAccess,
} from '../../utils/siaPermissions'

function pathFromPageUrl(url) {
    if (!url && typeof window !== 'undefined') {
        return window.location.pathname
    }
    const path = String(url || '').split('?')[0]
    return path.startsWith('/') ? path : `/${path}`
}

/** Videos del índice de capacitación (orden del menú). */
export const SIA_INDEX_VIDEO_SECTIONS = [
    ['bienvenido', 'Bienvenido'],
    ['cultura', 'Cultura'],
    ['comisiones-y-bonos', 'Comisiones y bonos'],
    ['producto', 'Producto'],
    ['como-llenar-formatos', 'Cómo llenar formatos'],
]

/** Rutas bajo Formación en campo (acordeón anidado). */
export const SIA_FIELD_TRAINING_ROUTES = [
    ['ruta-1-identidad', 'Identidad, autoconfianza y presencia profesional'],
    ['ruta-2-mentalidad', 'Mentalidad, disciplina y alto rendimiento'],
    ['ruta-3-prospeccion', 'Prospección y generación de oportunidades'],
]

export const SIA_FIELD_TRAINING_SLUG = 'formacion-en-campo'

/** Ruta 1: tarjetas de subtema. Dentro del subtema, lista lateral + video o PDF. */
export const SIA_FIELD_TRAINING_THEMES_BY_ROUTE = {
    'ruta-1-identidad': [
        'creer-en-la-carrera',
        'construir-autoconfianza',
        'conectar-con-personas',
        'presencia-y-seguridad',
    ],
    'ruta-2-mentalidad': [],
    'ruta-3-prospeccion': [],
}

export const SIA_FIELD_TRAINING_THEME_SLUGS = Object.values(SIA_FIELD_TRAINING_THEMES_BY_ROUTE).flat()

function IconCapacitacion() {
    return (
        <span className="menu-icon">
            <span className="svg-icon svg-icon-2">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" fill="currentColor" />
                    <path opacity="0.3" d="M12 13C8.13401 13 5 16.134 5 20V19H19V20C19 16.134 15.866 13 12 13Z" fill="currentColor" />
                </svg>
            </span>
        </span>
    )
}

function IconIndex() {
    return (
        <span className="menu-icon me-1">
            <span className="svg-icon svg-icon-2">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 6H20V8H4V6ZM4 11H20V13H4V11ZM4 16H14V18H4V16Z" />
                </svg>
            </span>
        </span>
    )
}

function IconBook() {
    return (
        <span className="menu-icon me-1">
            <span className="svg-icon svg-icon-2">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 6H13V20H4C3.45 20 3 19.55 3 19V7C3 6.45 3.45 6 4 6ZM18 6V18H6V4H18C19.1 4 20 4.9 20 6V20C20 21.1 19.1 22 18 22H6V20H18V6Z" />
                </svg>
            </span>
        </span>
    )
}

function IconTrophy() {
    return (
        <span className="menu-icon me-1">
            <span className="svg-icon svg-icon-2">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9H4V11H6V20H18V11H20V9H18V7H6V9ZM8 9H16V18H8V9ZM2 3H8V5H4V7H2V3ZM22 3V7H18V5H14V3H22Z" />
                </svg>
            </span>
        </span>
    )
}

function IconVideo() {
    return (
        <span className="menu-icon me-1">
            <span className="svg-icon svg-icon-2">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M4 8.5C4 7.11929 5.11929 6 6.5 6H13.5C14.8807 6 16 7.11929 16 8.5V15.5C16 16.8807 14.8807 18 13.5 18H6.5C5.11929 18 4 16.8807 4 15.5V8.5Z"
                        fill="currentColor"
                    />
                    <path
                        opacity="0.4"
                        d="M17.25 9.29289L20 7.5V16.5L17.25 14.7071C17.092 14.5889 17 14.4056 17 14.2121V9.78787C17 9.59441 17.092 9.41114 17.25 9.29289Z"
                        fill="currentColor"
                    />
                </svg>
            </span>
        </span>
    )
}

function IconExam() {
    return (
        <span className="menu-icon">
            <span className="svg-icon svg-icon-2">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 2h10a2 2 0 0 1 2 2v16l-4-2-4 2-4-2-4 2V4a2 2 0 0 1 2-2zm1 5v2h8V7H8zm0 4v2h8v-2H8z" />
                </svg>
            </span>
        </span>
    )
}

function IconIdealSum() {
    return (
        <span className="menu-icon">
            <span className="svg-icon svg-icon-2">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5.97 4.06L14.09 6l1.41 1.41L16.91 6l1.06 1.06-1.41 1.41 1.41 1.41-1.06 1.06-1.41-1.41-1.41 1.41-1.06-1.06 1.41-1.41-1.41-1.41zM6.25 7.72h5v1.5h-5v-1.5zM11.5 16h-2v2H8v-2H6v-1.5h2v-2h1.5v2h2V16zm6.5 1.25h-5v-1.5h5v1.5zm0-2.5h-5v-1.5h5v1.5z" />
                </svg>
            </span>
        </span>
    )
}

/**
 * Menú lateral SIA: Capacitación queda abierto. Libros y Cédula A van dentro.
 * Suma asegurada ideal queda fuera de ese acordeón.
 *
 * @param {{ variant: 'learner' | 'manage' }} props
 */
export default function SiaPanelMenu({ variant }) {
    const page = usePage()
    const { url } = page
    const menu = page.props.sia_capacitacion_menu || []
    const pathname = pathFromPageUrl(url)
    const manage = variant === 'manage'
    const canViewModule = (module) => canViewSiaModule(module, manage)

    const sectionItemsPrefix = (slug) => `/admin/sia/manage/sections/${slug}/items`

    const examHref = (slug) => (manage ? route('sia.manage.exams.edit', slug) : route('sia.exam.show', slug))

    const examActive = (slug) =>
        manage
            ? pathname === `/admin/sia/manage/examenes/${slug}/editar`
            : pathname === `/admin/sia/secciones/${slug}/examen`

    const videoSectionActive = (slug) => {
        if (examActive(slug)) {
            return true
        }
        if (manage) {
            const prefix = sectionItemsPrefix(slug)
            return pathname === prefix || pathname.startsWith(`${prefix}/`)
        }
        const sectionPath = `/admin/sia/${slug}`
        return pathname === sectionPath || pathname.startsWith(`${sectionPath}/`)
    }

    const branchActive = (node) =>
        videoSectionActive(node.slug) || (node.children || []).some((child) => videoSectionActive(child.slug))

    const videoSectionsActive = menu.some((node) => branchActive(node))

    const administrarActive = manage && (pathname === '/admin/sia/manage' || pathname === '/admin/sia/manage/')

    const librosLearnerPrefix = '/admin/sia/capacitacion/libros'
    const librosManagePrefix = '/admin/sia/manage/libros'
    const librosActive = manage
        ? pathname === librosManagePrefix || pathname.startsWith(`${librosManagePrefix}/`)
        : pathname === librosLearnerPrefix || pathname.startsWith(`${librosLearnerPrefix}/`)

    const lideresLearnerPrefix = '/admin/sia/capacitacion/lideres'
    const lideresManagePrefix = '/admin/sia/manage/lideres'
    const lideresActive = manage
        ? pathname === lideresManagePrefix || pathname.startsWith(`${lideresManagePrefix}/`)
        : pathname === lideresLearnerPrefix || pathname.startsWith(`${lideresLearnerPrefix}/`)

    const formatosLearnerPrefix = '/admin/sia/capacitacion/formatos-adicionales'
    const formatosManagePrefix = '/admin/sia/manage/formatos-adicionales'
    const formatosLearnerActive = !manage && (pathname === formatosLearnerPrefix || pathname.startsWith(`${formatosLearnerPrefix}/`))
    const formatosManageOpen =
        manage && (pathname === formatosManagePrefix || pathname.startsWith(`${formatosManagePrefix}/`))
    const formatosManageListadoActive =
        manage &&
        (pathname === `${formatosManagePrefix}/documentos` || pathname.startsWith(`${formatosManagePrefix}/documentos/`))
    const formatosManageCategoriasActive =
        manage &&
        (pathname === `${formatosManagePrefix}/categorias` || pathname.startsWith(`${formatosManagePrefix}/categorias/`))

    const capacitacionAccordionOpen = manage
        ? videoSectionsActive ||
          administrarActive ||
          lideresActive ||
          formatosManageOpen ||
          librosActive ||
          /\/admin\/sia\/manage\/items\/\d+/.test(pathname) ||
          /\/admin\/sia\/manage\/sections\/[\w-]+\//.test(pathname)
        : pathname === '/admin/sia' ||
          videoSectionsActive ||
          lideresActive ||
          formatosLearnerActive ||
          librosActive ||
          pathname.startsWith('/admin/sia/capacitacion/')

    const capacitacionClass = 'menu-item menu-accordion hover show' + (capacitacionAccordionOpen ? ' active' : '')

    const librosHref = manage ? route('sia.manage.libros.index') : route('sia.capacitacion.libros.index')
    const lideresHref = manage ? route('sia.manage.lideres.index') : route('sia.capacitacion.lideres.index')
    const showIndexAccordion = canViewModule('index')

    const showCapacitacionMenu = hasAnySiaCapacitacionMenuAccess(manage)
    const idealSumPath = '/admin/sia/suma-asegurada-ideal'
    const idealSumActive = pathname === idealSumPath

    return (
        <>
            {showCapacitacionMenu && (
                <div className={capacitacionClass.trim()}>
                    <span className="menu-link">
                        <IconCapacitacion />
                        <span className="menu-title text-uppercase">Capacitación</span>
                    </span>
                    <div className="menu-sub menu-sub-accordion">
                        {showIndexAccordion &&
                            menu.map((node) => {
                                const children = node.children || []
                                const hrefFor = (slug) =>
                                    manage ? route('sia.manage.section.items', slug) : route('sia.section.show', slug)
                                if (!children.length) {
                                    return (
                                        <React.Fragment key={node.slug}>
                                            <div className="menu-item ps-3">
                                                <Link
                                                    className={
                                                        'menu-link d-flex align-items-center ' +
                                                        (videoSectionActive(node.slug) && !examActive(node.slug) ? 'active' : '')
                                                    }
                                                    href={hrefFor(node.slug)}
                                                >
                                                    <IconVideo />
                                                    <span className="menu-title">{node.title}</span>
                                                </Link>
                                            </div>
                                            {node.has_exam && (
                                                <div className="menu-item ps-6">
                                                    <Link
                                                        className={
                                                            'menu-link d-flex align-items-center ' +
                                                            (examActive(node.slug) ? 'active' : '')
                                                        }
                                                        href={examHref(node.slug)}
                                                    >
                                                        <span className="menu-title">Examen</span>
                                                    </Link>
                                                </div>
                                            )}
                                        </React.Fragment>
                                    )
                                }
                                return (
                                    <div
                                        data-kt-menu-trigger="click"
                                        className={
                                            'menu-item menu-accordion ps-3 ' +
                                            (branchActive(node) ? 'active hover show' : '')
                                        }
                                        key={node.slug}
                                    >
                                        <span className="menu-link">
                                            <IconVideo />
                                            <span className="menu-title">{node.title}</span>
                                            <span className="menu-arrow"></span>
                                        </span>
                                        <div className="menu-sub menu-sub-accordion">
                                            {children.map((child) => (
                                                <React.Fragment key={child.slug}>
                                                    <div className="menu-item ps-3">
                                                        <Link
                                                            className={
                                                                'menu-link d-flex align-items-center ' +
                                                                (videoSectionActive(child.slug) && !examActive(child.slug) ? 'active' : '')
                                                            }
                                                            href={hrefFor(child.slug)}
                                                        >
                                                            <span className="menu-title">{child.title}</span>
                                                        </Link>
                                                    </div>
                                                    {child.has_exam && (
                                                        <div className="menu-item ps-6">
                                                            <Link
                                                                className={
                                                                    'menu-link d-flex align-items-center ' +
                                                                    (examActive(child.slug) ? 'active' : '')
                                                                }
                                                                href={examHref(child.slug)}
                                                            >
                                                                <span className="menu-title">Examen</span>
                                                            </Link>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </div>
                                )
                            })}
                        {manage && showIndexAccordion && (
                            <div className="menu-item ps-3">
                                <Link
                                    className={'menu-link d-flex align-items-center ' + (administrarActive ? 'active' : '')}
                                    href={route('sia.manage.index')}
                                >
                                    <IconIndex />
                                    <span className="menu-title">Administrar</span>
                                </Link>
                            </div>
                        )}

                        {canViewModule('libros') && (
                            <div className="menu-item ps-3">
                                <Link className={'menu-link d-flex align-items-center ' + (librosActive ? 'active' : '')} href={librosHref}>
                                    <IconBook />
                                    <span className="menu-title">Libros</span>
                                </Link>
                            </div>
                        )}

                        {canViewModule('lideres') && (
                            <div className="menu-item ps-3">
                                <Link
                                    className={'menu-link d-flex align-items-center ' + (lideresActive ? 'active' : '')}
                                    href={lideresHref}
                                >
                                    <IconTrophy />
                                    <span className="menu-title">Cédula A</span>
                                </Link>
                            </div>
                        )}

                        {!manage && showIndexAccordion && (
                            <div className="menu-item ps-3">
                                <Link
                                    className={'menu-link d-flex align-items-center ' + (pathname === '/admin/sia/calificacion-final' ? 'active' : '')}
                                    href={route('sia.grades.index')}
                                >
                                    <IconExam />
                                    <span className="menu-title">Calificación final</span>
                                </Link>
                            </div>
                        )}

                    </div>
                </div>
            )}
            {showCapacitacionMenu && (
                <div className="menu-item">
                    <Link
                        className={'menu-link d-flex align-items-center ' + (idealSumActive ? 'active' : '')}
                        href={route('sia.ideal-sum.show')}
                    >
                        <IconIdealSum />
                        <span className="menu-title">Suma asegurada ideal</span>
                    </Link>
                </div>
            )}
            {manage && canViewModule('examenes') && (
                <div className="menu-item">
                    <Link
                        className={'menu-link d-flex align-items-center ' + (pathname.startsWith('/admin/sia/manage/examenes') ? 'active' : '')}
                        href={route('sia.manage.exams.index')}
                    >
                        <IconExam />
                        <span className="menu-title">Exámenes</span>
                    </Link>
                </div>
            )}
        </>
    )
}
